'use client';

import { SectionCard, SectionParagraph } from './section-card';
import { FrameGrid } from './frame-grid';
import type { DefinitionStoryboard } from '@/hooks/use-definition';

interface StoryboardTemplateProps {
  storyboard: DefinitionStoryboard;
}

export function StoryboardTemplate({ storyboard }: StoryboardTemplateProps) {
  const frames = Array.isArray(storyboard.frames) ? storyboard.frames : [];

  return (
    <div className="space-y-6">
      {/* Narrative */}
      {storyboard.narrative && (
        <SectionCard title="Story Narrative">
          <SectionParagraph text={storyboard.narrative} />
        </SectionCard>
      )}

      {/* Frames */}
      {frames.length > 0 && (
        <SectionCard title="Storyboard Frames">
          <FrameGrid frames={frames} />
        </SectionCard>
      )}

      {/* Assumptions */}
      {storyboard.assumptions && (
        <SectionCard title="Assumptions" dotColor="bg-amber-500" titleColor="text-amber-600" borderColor="border-amber-200">
          <SectionParagraph text={storyboard.assumptions} />
        </SectionCard>
      )}
    </div>
  );
}
